import { config } from "../config/config";
import { getAllActiveSubscriptionsDeepQuery } from "../services/billingService";
import { getPaymentMethodByPlanId } from "../services/paymentService";
import { makeBaseContentAsStarzplay } from "./commonUtils";
import { getAddOnByName, isStandAloneAddon } from "./subscriptionUtils";
export const STARZ = "starz";
export const STARZPLAY = "starzplay";

export async function isInitiateConcurrencyFlow(addOnName) {
  const addOnContentName = makeBaseContentAsStarzplay(addOnName);
  try {
    const { selectedSubscription } = await getPlanIdFromDeepQuery(addOnContentName);
    if (selectedSubscription) {
      return true;
    }
    return false; // don't initiate concurrency if we don't found any subscription
  } catch (error) {
    return false; // don't initiate concurrency if API fails
  }
}

export async function getConcurrency(addOnName) {
  const addOnContentName = makeBaseContentAsStarzplay(addOnName);
  const defaultConcurrency = config.get().concurrency.defaultValue;
  let concurrencyObj = { isAllowPlayback: true, concurrency: defaultConcurrency };
  try {
    const { planId, selectedSubscription } = await getPlanIdFromDeepQuery(addOnContentName);
    if (!selectedSubscription || planId === 0) {
      return concurrencyObj;
    }
    // const planId = 1766; // for Testing
    const paymentMethodData = await getPaymentMethodByPlanId.call(this, planId);
    if (paymentMethodData?.paymentPlans) {
      const plan = paymentMethodData.paymentPlans.filter(plan => plan.esbPlanId === planId);
      if (plan && plan.length > 0) {
        const planName = plan[0].planName;
        const concurrency = paymentMethodData?.configuration?.[`${planName}_concurrency`];
        concurrencyObj = { isAllowPlayback: false, concurrency: concurrency || defaultConcurrency };
        return concurrencyObj;
      }
    }
    // If we couldn't find the plan or concurrency, allow playback
    concurrencyObj = { isAllowPlayback: true, concurrency: defaultConcurrency };
    return concurrencyObj;
  } catch (error) {
    // If any error occurs during API calls, allow playback
    console.error("Error fetching concurrency:", error);
    concurrencyObj = { isAllowPlayback: true, concurrency: defaultConcurrency };
    return concurrencyObj;
  }
}
export async function getPlanIdFromDeepQuery(addOnName) {
  const addOnNameValue = addOnName === STARZ ? STARZPLAY : addOnName;
  const returnObj = { selectedSubscription: null, planId: null };
  try {
    const response = await getAllActiveSubscriptionsDeepQuery();
    const allSubscriptions = (response && response.subscriptions) || [];
    if (allSubscriptions && allSubscriptions.length > 0) {
      let selectedSubscription = allSubscriptions.filter(arr => arr.name === addOnNameValue);
      selectedSubscription = selectedSubscription && selectedSubscription.length > 0 ? selectedSubscription[0] : null;
      if (!selectedSubscription) {
        return returnObj;
      }
      const planId = selectedSubscription && selectedSubscription.paymentPlanId;
      return { selectedSubscription: selectedSubscription, planId: planId };
    }
  } catch (error) {
    // If Subscription call failed (We should not restrict user to playback)
    return returnObj;
  }
}
// Only use for concurrency
export function getSuperParentAddOnNameForConcurrency(addons, addOnName) {
  if (isStandAloneAddon(addOnName)) {
    return addOnName;
  } else {
    const parentAddOn = getParentAddOnForConcurrency(addOnName);
    return parentAddOn ? getSuperParentAddOnNameForConcurrency(addons, parentAddOn.name) : null;
  }
}
export function getParentAddOnForConcurrency(addOnName) {
  let parentAddOn;
  const addOnObj = getAddOnByName(addOnName); // not to check isStandAlone
  if (addOnObj && addOnObj.configuration["includedIn"]) {
    // check for includedIn
    parentAddOn = getAddOnByName(addOnObj.configuration["includedIn"]);
  }
  return parentAddOn;
}
